
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/improve-stability",
      function () {
        return require("private-next-pages/solutions/improve-stability.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/improve-stability"])
      });
    }
  